import { useState, useEffect } from "react";
import firebaseConfig from "../firebase"
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { Grid, Container, Button, Paper, Stack, Modal , Card, CardContent, Typography,  Divider} from "@mui/material";
import { useNavigate } from "react-router-dom";
//COMPONENTS
import RichTextCreate from "./RichTextCreate";
import RichTextUpdate from "./RichTextUpdate";
//ICONS
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useDispatch } from "react-redux";
import { getFirestore } from 'firebase/firestore';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    bgcolor: 'background.paper',
    border: '2px solid #000,',
    boxShadow: 24,
    p: 4,
  };

const card = {

  width: '350px',
  height: 'auto',
  borderRadius: 25,
  boxShadow: 4,
};

function RichText() {
    const db = getFirestore(firebaseConfig)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [content, setContent] = useState([]);
    const contentCollectionRef = collection(db, "Content");
    const [addModal, setAddModal] = useState(false);
    const addHandleClose = () => setAddModal(false);
    const [modal, setModal] = useState(false);
    const [item, setItem] = useState();
    const handleClose = () => setModal(false);


  useEffect(() => {
    const getContent = async () => {
      const data = await getDocs(contentCollectionRef);
      await setContent(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getContent();
  }, []);
    const deleteContent = async (id) => {
        const contentDoc = doc(db, "Content", id);
        await deleteDoc(contentDoc);
        alert("ลบเรียบร้อย")
        window.location.reload();
    };

    return (
        <Container>
         <Typography variant="h1" sx={{fontWeight:'bold', fontSize:'2.25vw', marginTop:"20px", fontFamily:'Prompt'}}>จัดการคู่มือ</Typography>
        <div>
        <Button style={{ float: "right", marginBottom: 10 }} 
        sx={{ fontFamily:'Prompt'}}

        onClick={() => navigate('/content/create')}
        variant="contained" color="success" startIcon={<AddCircleOutlineIcon/>}>เพิ่ม
        </Button>
      </div>

      
      <Grid container spacing={2}>
    {content.map((row) => (
      <Grid item xs={4}>
      <Card style={card}>
        <CardContent>

          <Typography gutterBottom="true" variant="h1" align="left"  sx={{fontSize:'1.5vw', fontWeight:'bold', fontFamily:'Prompt'}}>
            {row.contentType}
          </Typography>
          <Divider light="true"/>
        </CardContent>
        <CardContent>
        <Stack spacing={8} direction="row" justifyContent="center">                  
                  <Button
                      sx={{ fontFamily:'Prompt'}}
                      variant="text"
                    onClick={() => {
                      deleteContent(row.id);
                      }}color="error" size="large" startIcon={<DeleteOutlineIcon/>}>
                    ลบ
                  </Button>
                  
                  <Button variant="contained" 
                  sx={{ fontFamily:'Prompt'}} onClick={() => {
                      dispatch({
                        type:'richtext',
                        payload: {
                          contentText: row.contentText,
                          contentType: row.contentType,
                        }
                      })
                      navigate('/content/update/' + row.id)
                    }} startIcon={<EditIcon/>}>แก้ไข</Button>


                </Stack>
        </CardContent>

      </Card>
      </Grid>
    ))}
    </Grid>


    </Container>

    );
}

export default RichText